@if (isLauncherDisplayable()) {
    <div
        class="flex h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-malou-color-primary"
        (click)="onNeedHelpButtonClick()">
        <mat-icon class="!h-8 !w-8 text-white" [svgIcon]="SvgIcon.FRONT_CHAT"></mat-icon>
    </div>
}
